import React, {useCallback, useEffect, useMemo, useState} from "react";
import {
  Grid,
  Button
} from "@mui/material";

import PresentationCurrentPlan from "../components/presentation-current-plan";
import PresentationLayout2 from "../components/presentation-layout2";
import PresentationFuture from "../components/presentation-future";
import { useDispatch, useSelector } from "react-redux";
import {
  SAGA_GET_FUTURE_CASH_FLOW,
  SAGA_GET_PLAN_CASH_FLOW,
  SAGA_GET_PLANINPUT,
  ACTION_CLEAR_FUTURE_CASH_FLOW
} from "../shared/constants";
import { useCookies } from "react-cookie";
import PresentationAssumptions from "../components/presentation-assumptions";
import PresentationNavBar from "../components/presentation-navbar";
import { FancyButtonNavBar } from "../components/presentation-fancy-button-navbar";
import RoadmapReport from "../components/roadmap-report";
import { getAdjustments, getClient, getRILAHistoricReturns } from "../shared/api";

import { useModal } from "../hooks";
import { currencyFormatNoDecimals } from "../shared/shared";
import LeaveDataModal from "../components/leave-data-modal";


const PlanOutput = () => {
  // THIS NEEDS TO BE ONE SO STARTS ON CURRENT DESTINATION.
  // DO NOT CHANGE WITHOUT CONSULTING GENE FIRST.
  // SERIOUSLY.
  const [presentationPage, setPresentationPage] = useState(1);
  const dispatch = useDispatch();
  const client = useSelector((state) => state.dataStore.get("currentClient"));
  // const planInput = useSelector(state => state.dataStore.getIn(['planInput']));

  const currentCashInflow = useSelector((state) => state.dataStore.get("currentPlanCashFlow"));
  const futureCashInflow = useSelector((state) => state.dataStore.get("currentFuturePlanCashFlow"));
  const isFutureDestinationLocked = useSelector(state => state.dataStore.get('lockFutureDestination'));

  const showFiaReport = futureCashInflow !== null ? futureCashInflow.toJS().fiaReport?.flat()?.length > 0 : false;

  const [cookies, setCookie] = useCookies(["loginToken"]);
  const ASSUMPTIONS = 0;
  const CURRENT_ROADMAP = 1;
  const FUTURE = 2;
  const { isOpen, openModal, closeModal } = useModal();
  const [showLeaveChangesModal, updateShowLeaveChangesModal] = useState(false);
  const [pageUpdated, updatePageUpdated] = useState(false);
  const fpid = useSelector((state) => state.dataStore.get("currentFPId"));

  // THE FIRST PAGE USER SHOULD SEE IS CURRENT DESTINATION ONCE THE PRESENTATION IS OVER.
  const [activeLink, setActiveLink] = useState({
    [ASSUMPTIONS]: false,
    [CURRENT_ROADMAP]: true,
    [FUTURE]: false
  })
  const handleActiveLink = (idx) => {
    setActiveLink({
      [ASSUMPTIONS]: false,
      [CURRENT_ROADMAP]: false,
      [FUTURE]: false,
      [idx]: true
    })
    setPresentationPage(idx);
  }

  const currentPlanInflow = useMemo(() => {
    return currentCashInflow?.toJS();
  }, [currentCashInflow])

  const futurePlanInflow = useMemo(() => {
    return futureCashInflow?.toJS();
  }, [futureCashInflow])



  const setPlanInput = async (sAndPHistoricalData) => {
    const responseActualPlan = await getClient(client.getIn(['client', 'id']), cookies["loginToken"]);
    const responseFuturePlan = await getAdjustments(client.getIn(['client', 'id']), cookies["loginToken"]);
    dispatch({
      type: SAGA_GET_PLANINPUT,
      value: {
        accounts: responseActualPlan.data.accounts,
        goals: responseActualPlan.data.goals,
        incomes: responseActualPlan.data.incomes,
        assumptions: responseActualPlan.data.planAssumptions,
        fiaTransfers: responseFuturePlan.fiaTransfers.map(item => {
          return {
            ...item,
            averageReturn: sAndPHistoricalData.averageReturn / 100,
            standardDeviation: sAndPHistoricalData.standardDeviation / 100,
          }
        }),
        insuranceTransfers: responseFuturePlan.insuranceTransfers,
        rothTransfers: responseFuturePlan.rothTransfers,
        spendingGoals: responseFuturePlan.spendingGoals
      }
    });

    dispatch({
      type: SAGA_GET_PLAN_CASH_FLOW,
      value: client.getIn(['client', 'id']),
      token: cookies["loginToken"],
    });

    if (responseFuturePlan.fiaTransfers.length !== 0 || responseFuturePlan.insuranceTransfers.length !== 0 || responseFuturePlan.rothTransfers.length !== 0 || responseFuturePlan.spendingGoals === 0) {
      dispatch({
        type: SAGA_GET_FUTURE_CASH_FLOW,
        value: client.getIn(['client', 'id']),
        token: cookies["loginToken"],
      });
    } else {
      dispatch({
        type: ACTION_CLEAR_FUTURE_CASH_FLOW
      });
    }
  }

  useEffect(() => {
    getRILAHistoricReturns(cookies["loginToken"]).then(response => {
      setPlanInput(response);
    });
  }, [])

  const generateRoadmapReport = () => {
    openModal();
  }

  const calculateEndingPortfolioValueCashInflow = (assumption) => {
    const taxableAccValue = assumption?.taxableAccountBalance;
    const taxDeferredAccBalance = assumption?.taxDeferredAccountBalance;
    const taxExemptAccBalance = assumption?.taxExemptAccountBalance;
    const fiaAcctBalance = assumption?.fiaAccountBalance;

    return taxableAccValue + taxDeferredAccBalance + taxExemptAccBalance + fiaAcctBalance;
  }

  //CALCULUS FUTURE TABLE (Future destination tab)
  const listCalculusFutureTableInflow = currentPlanInflow?.accountsSummary.filter((item, index) => {
    return index === 10 || index === 20 || index === currentPlanInflow.accountsSummary.length - 1;
  }).map(item => {
    const currentEndingValue = item.totalAccountValue;
    let futureEndingValue = 0;
    if (futurePlanInflow?.accountsSummary) {
      const futureItem = futurePlanInflow?.accountsSummary.find(a => a.year === item.year);
      if (futureItem && futureItem.totalAccountValue) futureEndingValue = futureItem.totalAccountValue;
    }

    return {
      year: item?.year,
      age: item?.clientAge,
      totalCurrent: currencyFormatNoDecimals(currentEndingValue),
      totalFuture: currencyFormatNoDecimals(futureEndingValue),
      increase: currencyFormatNoDecimals(futureEndingValue - currentEndingValue)
    };
  });

  const totalTaxesPaidFuture = useMemo(() => {
    return futurePlanInflow?.cashOutflow?.reduce((previousValue, currentValue) => {
      return previousValue + (currentValue?.incomeTax + currentValue?.capitalGainsTax);
    }, 0) || 0;
  }, [futurePlanInflow?.cashOutflow]);

  const socialSecurityTaxesFuture = useMemo(() => {
    return futurePlanInflow?.cashOutflow?.reduce((previousValue, currentValue) => {
      return previousValue + currentValue.socialSecurityTax;
    }, 0) || 0;
  }, [futurePlanInflow?.cashOutflow]);

  //CALCULATE CURRENT PLAN (Current destination tab)
  const listCalculusCurrentPlanInflow = currentPlanInflow?.accountsSummary.filter((item, index) => index === 10 || index === 20 || index === currentPlanInflow?.accountsSummary.length - 1).map(item => {

    const endingValue = calculateEndingPortfolioValueCashInflow(item);

    return {
      age: item?.clientAge,
      year: item?.year,
      endingValue: currencyFormatNoDecimals(endingValue)
    }
  });


  const totalTaxesPaidCurrent = useMemo(() => {
    return currentPlanInflow?.cashOutflow.reduce((previousValue, currentValue) => {
      return previousValue + (currentValue.incomeTax + currentValue.capitalGainsTax);
    }, 0) || 0;
  }, [currentPlanInflow?.cashOutflow]);

  const socialSecurityTaxesPaidCurrent = useMemo(() => {
    return currentPlanInflow?.cashOutflow.reduce((previousValue, currentValue) => {
      return previousValue + currentValue.socialSecurityTax;
    }, 0) || 0;
  }, [currentPlanInflow?.cashOutflow]);

  const successProbabilityCurrent = currentPlanInflow?.successProbability || 0;
  const successProbabilityFuture = futurePlanInflow?.successProbability || 0;


  const futureDestinationText = `By utilizing various financial strategies including volatility buffers, ROTH IRA conversions, lifetime income annuities, life insurance, and making your portfolio as efficient as possible, your probability of success has changed from ${successProbabilityCurrent}% to ${successProbabilityFuture}%`
  const currentPlanContentText = `Based on Monte Carlo Simulation (a random sampling to obtain numerical results) The IFW Retirement Roadmap Software has run 1,000 different simulations and determined your percentage chance of not running out of money. This means that out of 1,000 potential outcomes, you achieved your goals ${successProbabilityCurrent * 10} times`
  const currentPlanFooterText = `Our goal is to make sure you have the highest probability of not running out of money in retirement. Let's get there!`

  const updateDataAfterCalculation = () => {
    getRILAHistoricReturns(cookies["loginToken"]).then(response => {
      setPlanInput(response);
    });
  };

  const goToClientList = () => {
    if(pageUpdated) {
      updateShowLeaveChangesModal(true);
    } else {
      const id = (fpid !== undefined && fpid !== null) ? fpid : "";
      const target = `/ifw-users/2/${id}`;
      window.location.href = target;
    }
  };

  const isPageUpdated = (val) => {
    updatePageUpdated(val);
  };

  return (
    <Grid>
      <PresentationLayout2
          goToClientList={goToClientList}
      >
        {<></>}
        {<PresentationNavBar>
          {<div className="container-up-banner">
            <div className="row">
              <FancyButtonNavBar
                activeLink={activeLink[ASSUMPTIONS]}
                onClick={() => handleActiveLink(ASSUMPTIONS)}
                text={"Assumptions"}
                shadow={false} />

              <FancyButtonNavBar
                activeLink={activeLink[CURRENT_ROADMAP]}
                onClick={() => handleActiveLink(CURRENT_ROADMAP)}
                text={"Current Destination"} />

              <FancyButtonNavBar
                activeLink={activeLink[FUTURE]}
                className={isFutureDestinationLocked ? "locked" : ""}
                onClick={() => {
                  if (isFutureDestinationLocked) return;
                  handleActiveLink(FUTURE)
                }}
                text={"Future Destination"} />
            </div>
            <div className="roadmap-button">
              <Button onClick={generateRoadmapReport}> Roadmap Report</Button>
            </div>
          </div>}

          {<>
            {presentationPage == ASSUMPTIONS && (
              <PresentationAssumptions
                  updateDataAfterCalculation={updateDataAfterCalculation}
                  isPageUpdated={isPageUpdated}
              />
            )}
            {presentationPage == CURRENT_ROADMAP && (
              <Grid mt={8} style={{ display: 'flex', justifyContent: 'center' }}>
                <PresentationCurrentPlan
                  tableCurrent={listCalculusCurrentPlanInflow ? listCalculusCurrentPlanInflow : []}
                  totalSS={socialSecurityTaxesPaidCurrent}
                  totalTaxesPaid={totalTaxesPaidCurrent}
                  successProbabilityCurrent={successProbabilityCurrent}
                  currentPlanContentText={currentPlanContentText}
                />
              </Grid>
            )}
            {presentationPage == FUTURE && (
              <Grid mt={8} style={{ display: 'flex', justifyContent: 'center' }}>
                <PresentationFuture
                  tableCurrentFuture={listCalculusFutureTableInflow ? listCalculusFutureTableInflow : []}
                  futurePlanCashflow={futurePlanInflow ? futurePlanInflow : []}
                  currentPlanCashflow={currentPlanInflow ? currentPlanInflow : []}
                  totalSSCurrent={socialSecurityTaxesPaidCurrent}
                  totalTaxesPaidCurrent={totalTaxesPaidCurrent}
                  totalSSFuture={socialSecurityTaxesFuture}
                  totalTaxesPaidFuture={totalTaxesPaidFuture}
                  successProbabilityCurrent={successProbabilityCurrent}
                  successProbabilityFuture={successProbabilityFuture}
                  futureDestinationText={futureDestinationText}
                  showFiaReport={showFiaReport}
                />
              </Grid>
            )}
          </>}
        </PresentationNavBar>}
      </PresentationLayout2>
      {isOpen && <RoadmapReport
        open={isOpen}
        handleClose={closeModal}
        client={client.getIn(['client']).toJS()}
        token={cookies["loginToken"]}
        tableCurrentFuture={listCalculusFutureTableInflow ? listCalculusFutureTableInflow : []}
        tableCurrent={listCalculusCurrentPlanInflow ? listCalculusCurrentPlanInflow : []}
        totalSSCurrent={socialSecurityTaxesPaidCurrent}
        totalTaxesPaidCurrent={totalTaxesPaidCurrent}
        totalSSFuture={socialSecurityTaxesFuture}
        totalTaxesPaidFuture={totalTaxesPaidFuture}
        futureDestinationText={futureDestinationText}
        currentPlanContentText={currentPlanContentText}
        currentPlanFooterText={currentPlanFooterText}
        successProbabilityCurrent={successProbabilityCurrent}
        successProbabilityFuture={successProbabilityFuture}
        showFiaReport={showFiaReport}
      />}
      <LeaveDataModal
          open={showLeaveChangesModal}
          handleCancel={() => {
            updateShowLeaveChangesModal(false);
          }}
          handleLeave={() => {
            const id = (fpid !== undefined && fpid !== null) ? fpid : "";
            const target = `/ifw-users/2/${id}`;
            window.location.href = target;
          }}
      />
    </Grid>
  );
};

export default PlanOutput;
